import * as React from "react";
import type { SVGProps } from "react";
const SvgQuotesCutoverIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="quotes_cutover_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M725.333 85.333A42.667 42.667 0 0 0 682.667 128v85.333a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128V896A42.667 42.667 0 1 0 768 896v-85.333a128 128 0 0 0 128-128V341.333a128 128 0 0 0-128-128V128a42.667 42.667 0 0 0-42.667-42.667zm-85.333 256a42.667 42.667 0 0 1 42.667-42.666H768a42.667 42.667 0 0 1 42.667 42.666v341.334A42.667 42.667 0 0 1 768 725.333h-85.333A42.667 42.667 0 0 1 640 682.667V341.333zM298.667 170.667A42.667 42.667 0 0 0 256 213.333v85.334a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128v85.333a42.667 42.667 0 1 0 85.333 0V768a128 128 0 0 0 128-128V426.667a128 128 0 0 0-128-128v-85.334a42.667 42.667 0 0 0-42.666-42.666zm-85.334 256A42.667 42.667 0 0 1 256 384h85.333A42.667 42.667 0 0 1 384 426.667V640a42.667 42.667 0 0 1-42.667 42.667H256A42.667 42.667 0 0 1 213.333 640V426.667z"
    />
  </svg>
);
export default SvgQuotesCutoverIcon;
